import { render, staticRenderFns } from "./px-status-badge.vue?vue&type=template&id=445b3767&scoped=true&"
import script from "./px-status-badge.vue?vue&type=script&lang=ts&"
export * from "./px-status-badge.vue?vue&type=script&lang=ts&"
import style0 from "./px-status-badge.vue?vue&type=style&index=0&id=445b3767&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445b3767",
  null
  
)

export default component.exports